<template>
  <fragment>
    <ShowImage class="row w-100 detail align-items-center;">
      <b-col
        cols="2"
        class="detail-data align-self-center"
        :class="{ invisible: fileSelected.length <= 0 }"
      >
        <div class="d-flex fs-sa-14">
          <p
            class="mb-0"
            :class="`${fileSelected.length >= limit ? 'text-danger' : ''}`"
          >
            {{ fileSelected.length }}
          </p>
          <p class="mb-0 mr-gd-1">/{{ limit }}</p>
          <p class="mb-0">{{ itemSelectedText }}</p>
        </div>
        <span>
          <span
            class="fs-sa-14 text-primary"
            style="cursor: pointer"
            @click="$emit('clear')"
          >
            <i class="far fa-times"></i> {{$t('engine.filemanager.itemDeselect', languageEngine)}}
          </span>
          <span
            v-if="selectDirectoryType === 'system'"
            class="fs-sa-14 text-danger"
            style="cursor: pointer"
            @click="openDialogDeleteFiles"
          >
            <span class="fs-sa-14 text-gray"> | </span>
            <i class="far fa-trash-alt"></i>
            {{$t('engine.filemanager.itemDelete', languageEngine)}}
          </span>
        </span>
      </b-col>
      <b-col
        cols="8"
        class="detail-image d-inline-flex p-0"
        style="overflow-x: scroll"
      >
        <div
          class="text-center mx-1 bg-light img position-relative"
          style="width: 42px; height: 42px; border: 1px solid #DFDFDF; border-radius: 2px;"
          v-for="img in fileSelected"
          :key="`preview_selected_${img.id}`"
          @click="$emit('setFileHightlight', img)"
          :class="{ active: fileHighlight && fileHighlight.id === img.id }"
        >
          <div class="icon-name" v-if="isDoc(img)">
            <span class="pdf" v-show="isDoc(img) && typeFile(img) == 'pdf'">
              <i class="fas fa-file-pdf"></i>
            </span>
            <span class="word" v-show="isDoc(img) && typeFile(img) == 'doc'">
              <i class="fas fa-file-word"></i>
            </span>
            <span class="powerpoint" v-show="isDoc(img) && typeFile(img) == 'ppt'">
              <i class="fas fa-file-powerpoint"></i>
            </span>
            <span class="excel" v-show="isDoc(img) && typeFile(img) == 'xls'">
              <i class="fas fa-file-excel"></i>
            </span>
            <span class="txt" v-show="isDoc(img) && typeFile(img) == 'txt'">
              <i class="fas fa-file-alt"></i>
            </span>
          </div>
          <img
            v-else
            class="rounded"
            :src="previewImage(img, 'r_60x60')"
            data-holder-rendered="true"
            style="width: 40px; height: 40px; object-fit: contain"
          />
        </div>
      </b-col>
      <b-col class="align-self-center px-gd-0">
        <b-button
          v-show="checkShowAddImage"
          class="float-right"
          :disabled="fileSelected.length == 0 || fileSelected.length > limit"
          variant="blue"
          @click="$emit('addImg')"
        >
          <i class="far fa-check" v-show="checkShowAddImage"></i> {{ getLabelBtnAddFile() }}</b-button
        >
        <b-button 
          v-show="['owner','reseller'].indexOf(adminType) != -1 && permissions.isPhotoStock == 0 && this.selectDirectoryType == 'unsplash'"
          class="float-right"
          variant="blue" @click="upgrade">
          {{$t('engine.common.dialogAlertLimitSlideSection.lblUpgradePackage', languageEngine)}}
        </b-button>
        <span 
          v-show="['owner','reseller'].indexOf(adminType) == -1 && permissions.isPhotoStock == 0 && this.selectDirectoryType == 'unsplash'"
          class="fs-sa-12 text-danger float-right"
        > 
          {{$t('engine.common.dialogAlertLimit.lblTitleLimit',languageEngine)}} 
        </span>
      </b-col>
    </ShowImage>
    <ConfirmDeleteFile @confirmed="deleteImg()" />
  </fragment>
</template>

<script>
import ConfirmDeleteFile from "./modal/ConfirmDeleteFile.vue";
import { ShowImage } from "./Filemanager.styled";
import fileService from "@services/fileService.js";
import { mapGetters } from "vuex";
export default {
  components: {
    ShowImage,
    ConfirmDeleteFile,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      permissions: "design/permissionWebsite/permissions",
      adminType: "design/userPreference/adminType",
      limitPermission: "design/page/limit",
    }),
    itemSelectedText() {
      if (this.fileSelected.length > 1) {
        return this.$t('engine.filemanager.multiItemSelect', this.languageEngine);
      } else {
        return this.$t('engine.filemanager.singleItemSelect', this.languageEngine);
      }
    },
    checkShowAddImage() {
      if(this.selectDirectoryType != 'unsplash') {
        return true;
      }else if(this.permissions.isPhotoStock == 1)  {
        return true;
      }else {
        return false;
      }
    },
  },
  methods: {
    openDialogDeleteFiles() {
      this.$bvModal.show("modal-confirm-delete-file");
    },
    previewImage(file, size) {
      const img = "image/jpg, image/jpeg, image/png, image/gif, image/webp";
      if (
        img.search(file.extension) != -1 &&
        this.selectDirectoryType == "system"
      ) {
        return file.url.replace("{{size}}", size);
      } else if (this.selectDirectoryType == "unsplash") {
        return (
          (file.urls && file.urls.thumb) || file.url.replace("{{size}}", size)
        );
      } else if (this.selectDirectoryType == "flaticon") {
        return file.url;
      }
    },
    isDoc(file) {
      const img = "image/jpg, image/jpeg, image/png, image/gif, image/webp";
      if (img.search(file.extension) != -1) {
        return false;
      } else {
        return true;
      }
    },
    typeFile(file) {
      const type = file.extension;
      let type_file = ``;
      const doc = "pdf, ppt, pptx, doc ,docx, xls,xlsx,txt";
      if (doc.toLowerCase().search(type.toLowerCase()) != -1) {
        switch (type.toLowerCase()) {
          case "pdf":
            type_file = "pdf";
            break;
          case "ppt":
          case "pptx":
            type_file = "ppt";
            break;
          case "doc":
          case "docx":
            type_file = "doc";
            break;
          case "xls":
          case "xlsx":
            type_file = "xls";
            break;
          default:
            type_file = "txt";
        }
      }
      return type_file;
    },
    deleteImg() {
      this.$emit("loading", true);
      const type = this.selectDirectoryID === "document" ? "document" : "image";
      const name = this.selectDirectoryName;
      const filesID = this.fileSelected.map((file) => parseInt(file.id, 10));
      fileService
        .deleteFiles({ filesID: filesID, type: type, folderName: name })
        .then((result) => {
          if (result.success) {
            this.$emit("loading", false);
            this.$emit("clear");
            this.$emit("callback");
            this.$store.dispatch("design/page/initImagesID");
          } else if (result.data.error) {
            this.$bvModal.show("modal-cannot-delete-dir");
          }
        });
    },
    getLabelBtnAddFile() {
      let label = "";
      if (
        this.selectDirectoryName == "Document" &&
        this.selectDirectoryType == "system"
      ) {
        label = this.$t('engine.filemanager.addDocument', this.languageEngine);
      } else {
        switch (this.selectDirectoryType) {
          case "icon":
          case "flaticon":
            label = "Add Icon";
            break;
          default:
            label = this.$t('engine.filemanager.addImg', this.languageEngine);
        }
      }
      return label;
    },
    upgrade() {
      if(this.limitPermission.packageID != 9) { // 6 = Free
        const url = `${process.env.VUE_APP_PUBLIC_URL}/${this.languageEngine}/upgradeplan`;
        window.open(url,'_blank');
      }
    },
  },
  props: {
    fileHighlight: {},
    fileSelected: {
      type: Array,
      default: () => [],
    },
    selectDirectoryID: {
      type: String,
    },
    selectDirectoryName: {
      type: String,
    },
    selectDirectoryType: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.renderSVG {
  width: 60px;
  height: 60px;
  svg {
    width: 100%;
    height: 100%;
  }
}
.pdf {
  color : #E13022;
}
.word {
  color : #3BA9FF;
}
.powerpoint {
  color : #F89605;
}
.excel {
  color : #429600;
}
.txt {
  color : #373E44;
}
.icon-name {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  svg {
      font-size: 22px;
  }
}
</style>
